import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TooltipDirective } from '@mode/capra';
import { DatePickerComponent } from '@mode/shared/ui';

@Component({
  standalone: true,
  selector: 'mode-range-input-field',
  imports: [CommonModule, DatePickerComponent, FormsModule, TooltipDirective],
  templateUrl: './range-input-field.component.html',
  styleUrls: ['./range-input-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RangeInputFieldComponent implements OnChanges {
  @Input() label = '';
  @Input() value: number | undefined;
  @Input() domainValue: number | undefined;
  @Input({ required: true }) isDate!: boolean;
  @Input() isBinned = false;

  @Output() valueChanged = new EventEmitter<number | undefined>();

  // Local copies so we don't modify the original inputs
  currentValue: number | undefined;
  currentDate: Date | undefined;
  startDate: Date | undefined;

  ngOnChanges(): void {
    this.currentValue = this.value;
    this.currentDate = this.isDate && this.currentValue != null ? new Date(this.currentValue) : undefined;
    this.startDate =
      this.isDate && this.value == null && this.domainValue != null ? new Date(this.domainValue) : undefined;
  }

  onKeyUp(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Enter' && input != null) {
      // Enter should submit
      input.blur();
    }
  }

  onInputCommit() {
    this.valueChanged.emit(this.currentValue);
  }

  onValueChange(value: number | undefined) {
    this.currentValue = value ?? undefined;
  }

  onDateChange(value: Date | undefined) {
    this.currentDate = value;
    this.currentValue = value?.getTime() ?? undefined;
    this.onInputCommit();
  }
}
